const _ = require('lodash');
import bookUtils from '@/utils/bookUtils.js';
import annotationUtils from '@/utils/annotationUtils.js';
import utils from '@/utils/utils.js';
import storeHelpers from '@/utils/storeHelpers.js';
import lzjs from 'lzjs';

const funcs = {
  getSummaryData: async function(handle, book, metadata, fromPage, toPage, summaryFiltersToHide, currentHeadingLevel) {
    const sections = bookUtils.getSectionsFromPageRange(book, metadata, fromPage, toPage);
  
    const highlights = {};
    sections.forEach(section => {
      highlights[section] = storeHelpers.getHighlightsForBookPage(handle, book.id, section);
      if (!highlights[section]) {
        delete highlights[section];
      }
    })

    const {attachments, resources} = storeHelpers.getAttachmentsAndResourcesForBook(handle, book.id);
    const attachmentsForPageRange = _.filter(attachments, function(att) {
        return sections.indexOf(att.section) >= 0;
    });    
    const attachmentsPerPage = _.groupBy(attachmentsForPageRange, "section");
    const resourcesById = _.keyBy(resources, "_id");
    const resourceObjectsForSummary = {};
    _.each(attachmentsPerPage, function(attachmentsOnPage, section) {
      resourceObjectsForSummary[section] = [];

      _.each(attachmentsOnPage, function(att) {
        const res = resourcesById[att.resource];

        if(res && res.category !== "drawing") {
          resourceObjectsForSummary[section].push({
            selector: att.selector,
            id: att._id,
            category: res.category,
            text: res.category === "note" ? res.base64text : res.title,
            private: res.private ? res.private.toString() : "false",
            bitmap: utils.resourceTypeImg(res.category, res.url).replace("static/img/resource-types/","")
          })
        }
      });
    });

    // console.log("highlights:", highlights);

    return {
      highlights: highlights,
      resources: resourceObjectsForSummary,
      book: book,
      sections: sections,
      summaryFiltersToHide: summaryFiltersToHide,
      headingContextLevel: currentHeadingLevel,
      basePath: metadata.basePath
    };
  },
  getPDFSummaryHTMLCompressed(handle, metadata, pdfHLText, summaryData) {
    var html = "";
    const {
      resources, 
      sections
    } = summaryData;

    sections.forEach(async function(section) {
      var pageHTML = "";
      const pageOneBased = parseInt(section);
      const pageDisplay = _.find(metadata.pages, page => page.page === pageOneBased).title;

      // Get highlights for page
      const highlightsForPage = _.filter(pdfHLText, hl => hl.section === section);

      // Sort highlights by %Y (top first)
      const highlightsSorted = _.orderBy(highlightsForPage, [
        function (hl) { return hl.hlData[5]; },
        function (hl) { return hl.hlData[4]; }
      ], ["desc", "asc"]);

      // merge highlights that got the same color and is close to each other
      var currentColor = -1;
      var firstHLObject = {};
      var firstIndex = 0;
      var highlightsMergedAndSorted = []
      // var hlTopYcoords = 0; // if hl are 200px from each other then create a new one
      // var hlBottomYcoords = 0;
      _.each(highlightsSorted, (hl, i) => {
        // console.log("highlightsSorted:", highlightsSorted);
        // hlBottomYcoords = hl.hlData[5];
        // var spaceBetweenHl = hlTopYcoords - hlBottomYcoords;
        // console.log("spaceBetweenHl:", spaceBetweenHl);
        // if (spaceBetweenHl === (hlBottomYcoords*-1) || spaceBetweenHl < 500) {
          // hlTopYcoords = hlBottomYcoords;
          if (currentColor === hl.hlData[2]) {
            // merge
            firstHLObject.hlText += " " + hl.hlText;
          } else {
            // skip first one
            firstIndex = i;
            firstHLObject = hl;
            highlightsSorted[firstIndex] = firstHLObject;
            currentColor = hl.hlData[2];
            highlightsMergedAndSorted.push(hl);
          }
        // } else {
        //   hlTopYcoords = hlBottomYcoords;
        //   highlightsMergedAndSorted.push(hl);
        // }
      })

      // Get annotations/resources for page, sort by %Y (smallest first)
      const resourcesAndAnnotationsForPage = _.orderBy(resources[section], res => parseFloat(res.selector));
      
      var annotationsAndPrivateResourcesForPage = _.filter(resourcesAndAnnotationsForPage, res => utils.isAnnotation(res) || res.private === "true");

      // filter out annotations if need be
      if(summaryData.summaryFiltersToHide.indexOf("itsi-annotations") >= 0) {
        annotationsAndPrivateResourcesForPage = [];
      }

      var resourcesForPage = _.filter(resourcesAndAnnotationsForPage, res => !utils.isAnnotation(res) && res.private === "false");
      // For each highlight:
      _.each(highlightsMergedAndSorted, hl => {
        const hlCSSClass = annotationUtils.getHLPenColors()[hl.hlData[2]].hlClass;

        // get HL rectangle (add 5% buffer around Y top and bottom)
        const hlRectTop = 100 - (hl.hlData[5]/100.0) - 5;
        const hlRectBottom = 100 - ((hl.hlData[5] - hl.hlData[7])/100.0) + 5;

        // add annotations with Y < hlY and not yet added
        annotationsAndPrivateResourcesForPage = _.filter(annotationsAndPrivateResourcesForPage, res => {
          const resY = parseFloat(res.selector);
          if(resY < hlRectTop) {
            pageHTML += funcs.getResourceAndAnnotationSummaryHTML(handle, res, 1);
            return false;
          }
          return true;
        });



      // - add hl HTML
      // - add attachments with Y inside HL rectangle
      // - add private attachments with Y inside HL rectangle
      // - add annotations inside HL rectangle

        pageHTML += "<div class='itsi-summary-paragraph'><div class='text-and-resources'><div class='itsi-hl-text' style='display:table' data-itsi-selector='" + pageOneBased + "'><div class='itsi-hl-banner " + hlCSSClass + "' style='width: 10px; height: 100%%; display: table-cell;'></div><div class='itsi-hl-text-inner' style='display: inline-block; padding-left: 10px;'>"
        pageHTML += hl.hlText;
        pageHTML += "</div></div><div class='itsi-hl-resources'>";
        // add resources part of this HL block
        resourcesForPage = _.filter(resourcesForPage, res => {
          const resY = parseFloat(res.selector);
          if(resY >= hlRectTop && resY <= hlRectBottom) {
            pageHTML += funcs.getResourceAndAnnotationSummaryHTML(handle, res, 1);
            return false;
          }
          return true;
        });

        pageHTML += "</div></div>";

        // add annotations and private resources part of this annotations block
        annotationsAndPrivateResourcesForPage = _.filter(annotationsAndPrivateResourcesForPage, res => {
          const resY = parseFloat(res.selector);
          if(resY >= hlRectTop && resY <= hlRectBottom) {
            pageHTML += funcs.getResourceAndAnnotationSummaryHTML(handle, res, 1);
            return false;
          }
          return true;
        });

        pageHTML += "</div>";
      });

      // add remaining annotations
      _.each(annotationsAndPrivateResourcesForPage, annot => {
        pageHTML += funcs.getResourceAndAnnotationSummaryHTML(handle, annot, 1);
      });

      // add page title
      if(pageHTML.length > 0) {
        html += "<div class='itsi-section-heading' style='display: block;'>Page " + pageDisplay + "</div>";
        html += pageHTML;
      }
    });

    return lzjs.compressToBase64(html);
  },
  getResourceAndAnnotationSummaryHTML(handle, res, comparison) {
    var html = "";
    
    var style = "style='padding:0; margin-left:0;'";
    if(comparison == 0) {
        style = "";
    }

    const img = handle.$config.get("basePathFiles") + utils.resourceTypeImg(res.category);
    
    if(res.category === "sketch") {
        html = "<div class='itsi-summary-freehand' " + style + " id='" + res.id + "'><img class='itsi-summary-resource-image' src='" + img + "'><div class='itsi-summary-freehand-text'>" + res.text + ". <span class='itsi-summary-freehand-link'> Click here to view.</span></div></div>";
    } else if(res.category === "note" && res.text) {
        html = "<div class='itsi-summary-note' " + style + " id='" + res.id + "'><img class='itsi-summary-resource-image' src='" + img + "'><div class='itsi-summary-note-text'>" + atob(res.text) + "</div></div>";
    } else if(res.private === "true") {
      html = "<div class='itsi-summary-note' " + style + " id='" + res.id + "'><img class='itsi-summary-resource-image' src='" + img + "'><div class='itsi-summary-note-text'>" + res.text + "</div></div>";
    } else {
      // doesn't need a itsi-summary-paragraph
      return "<div class='itsi-summary-resource' id='" + res.id + "'><img class='itsi-summary-resource-image' src='" + img + "'></div>";
    }

    return "<div class='itsi-summary-paragraph'>" + html + "</div>";
  }
}

export default funcs
